import { Dialog, ScrollArea, Stack } from '@mantine/core';
import { Text } from '@repo/foundations';
import { useCallback, useEffect, useState } from 'react';
import { useStyles } from './BackgroundJobProgress.styles';

interface MetricJobProgressProps {
	isExecuting: boolean;
	logs?: string;
	timeLimit?: number;
}

export function MetricJobProgress({
	isExecuting,
	logs,
	timeLimit = 50_000,
}: MetricJobProgressProps) {
	const { classes, theme } = useStyles();

	const [isOpen, setIsOpen] = useState(false);

	useEffect(() => {
		if (isExecuting) {
			setIsOpen(true);
		}
	}, [isExecuting]);

	useEffect(() => {
		if (timeLimit <= 0) return () => {};
		const timer = setTimeout(() => {
			setIsOpen(false);
		}, timeLimit);
		return () => clearTimeout(timer);
	}, [isExecuting, timeLimit]);

	const handleClose = useCallback(() => {
		setIsOpen(false);
	}, []);

	return (
		<Dialog
			className={classes.dialog}
			opened={isOpen}
			withCloseButton
			onClose={handleClose}
			size="xl"
		>
			<Stack p={0} mt={'xs'}>
				<ScrollArea
					className={`${classes.logs} horizontal-scroll`}
					offsetScrollbars
					type="auto"
					w={theme.other.space[120]}
					h={theme.other.space[100]}
				>
					<Stack>
						<Text size="xs" ff={'monospace'}>
							Submitting job
						</Text>
						{logs?.split('\n').map((line, idx) => (
							// eslint-disable-next-line react/no-array-index-key
							<Text size="xs" ff={'monospace'} key={idx}>
								{line}
							</Text>
						))}
					</Stack>
				</ScrollArea>
			</Stack>
		</Dialog>
	);
}
